const bnJSON = {
  Blueprints: 'ব্লুপ্রিন্টসমূহ',
  'Extended Sidebar': 'প্রসারিত সাইডবার',
  'Accent Sidebar': 'অ্যাকসেন্ট সাইডবার',
  'Accent Header': 'অ্যাকসেন্ট হেডার',
  'Boxed Sidebar': 'বক্সড সাইডবার',
  'Collapsed Sidebar': 'সঙ্কুচিত সাইডবার',
  'Bottom Navigation': 'নীচের নেভিগেশন',
  'Top Navigation': 'উপরের নেভিগেশন',
  'Lead Developer': 'প্রধান ডেভেলপার',
  'Mega menu': 'মেগা মেনু',
  Doctors: 'চিকিৎসকগণ',
  Reports: 'প্রতিবেদনসমূহ',
  Hospital: 'হাসপাতাল',
  Export: 'রপ্তানি',
  'Last year': 'গত বছর',
  Expenses: 'খরচসমূহ',
  Products: 'পণ্যসমূহ',
  Statistics: 'পরিসংখ্যান',
  General: 'সাধারণ',
  Automation: 'অটোমেশন',
  'Data Display': 'ডেটা প্রদর্শন',
  Calendar: 'ক্যালেন্ডার',
  Mailbox: 'মেলবক্স',
  Dashboards: 'ড্যাশবোর্ডসমূহ',
  Analytics: 'বিশ্লেষণ',
  Banking: 'ব্যাংকিং',
  Commerce: 'বাণিজ্য',
  Crypto: 'ক্রিপ্টো',
  Finance: 'অর্থায়ন',
  Fitness: 'ফিটনেস',
  Healthcare: 'স্বাস্থ্যসেবা',
  Helpdesk: 'হেল্পডেস্ক',
  Learning: 'শিক্ষা',
  Monitoring: 'পর্যবেক্ষণ',
  Tasks: 'কাজসমূহ',
  Applications: 'অ্যাপ্লিকেশনসমূহ',
  'File Manager': 'ফাইল ম্যানেজার',
  'Jobs Platform': 'চাকরি প্ল্যাটফর্ম',
  Messenger: 'মেসেঞ্জার',
  'Projects Board': 'প্রজেক্ট বোর্ড',
  Management: 'ব্যবস্থাপনা',
  Users: 'ব্যবহারকারীগণ',
  'List All': 'সব তালিকাভুক্ত করুন',
  'User Profile': 'ব্যবহারকারীর প্রোফাইল',
  Projects: 'প্রকল্পসমূহ',
  Shop: 'দোকান',
  Invoices: 'ইনভয়েসসমূহ',
  Login: 'লগইন',
  Register: 'নিবন্ধন',
  Status: 'অবস্থা',
  Settings: 'সেটিংস',
  'Language Switcher': 'ভাষা পরিবর্তনকারী',
  'Sign out': 'সাইন আউট'
};

export default bnJSON;
